const validate = (values) => {
  const errors = {};

  if (!values.code || values.code.trim() === '') {
    errors.code = 'Please enter diagnosis code';
  }
  if (!values.description) {
    errors.description = 'Please enter description';
  }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/validate.js